import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import RedBox from 'redbox-react';
import {SwitcherProvider} from 'switcheroo';
import {HashRouter, Routes, Route} from 'react-router-dom';
import AppHooksProvider from '~/components/AppHooksProvider';
import AnalyticsProvider from '~/components/AnalyticsProvider';
import {mounted} from '~/actions/AppActions';
import LocationInfo from '~/components/LocationInfo';
import rollbar from '~/vendor/rollbar';
import {AuthProvider} from '~/auth/AuthProvider';
import {__DEVELOPMENT__} from '~/utils/env';
import {SignalerProvider} from '~/adapters/signaler/SignalerContext';
import {SignalerFlags} from '~/components/Signaler/SignalerFlags';
import {PigmentThemeProvider} from '@customink/pigment-react';

const propTypes = {
  store: PropTypes.object.isRequired
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
class Ndx extends Component {
  static displayName = 'Ndx';
  static propTypes = propTypes;

  state = {
    error: null
  };

  componentDidMount() {
    this.props.store.dispatch(mounted());
  }

  componentDidCatch(err) {
    if (__DEVELOPMENT__) {
      this.setState({error: err});
    } else {
      rollbar.error(err, {
        errorBoundaryComponent: 'Ndx'
      });
    }
  }

  renderError() {
    return <RedBox error={this.state.error} />;
  }

  renderApp() {
    const app = (
      <>
        <div className="ndx-PreloadContainer">
          <div className="ndx-PreloadHeader">
            <div className="ndx-PreloadLogo" />
          </div>
          <div className="ndx-PreloadSpinner" />
        </div>
        <SwitcherProvider>
          <Provider key="provider" store={this.props.store}>
            <LocationInfo>
              <AuthProvider>
                <AnalyticsProvider>
                  <AppHooksProvider />
                </AnalyticsProvider>
              </AuthProvider>
            </LocationInfo>
          </Provider>
        </SwitcherProvider>
      </>
    );

    return (
      <PigmentThemeProvider>
        <SignalerProvider>
          <HashRouter>
            <Routes>
              <Route path="/signals" element={<SignalerFlags />} />
              <Route path="/*" element={app} />;
            </Routes>
          </HashRouter>
        </SignalerProvider>
      </PigmentThemeProvider>
    );
  }

  render() {
    const showError = __DEVELOPMENT__ && this.state.error;
    return showError ? this.renderError() : this.renderApp();
  }
}

export default Ndx;
